import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { PaymentUtils } from './../../../features/payment/public/report/utils/payment-utils';
import { Component, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaymentStore } from 'src/app/features/payment/public/report/store/payment-report.store';
import { QrCodeHandlerComponentComponent } from '../../qr-code-handler-component/qr-code-handler-component.component';
import { isManual } from 'src/app/utils/crypto-data-souce.utils';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';

@Component({
  selector: 'app-scan-qr-modal',
  imports: [TranslateModule, MatTooltip, QrCodeHandlerComponentComponent, ModalBaseComponent],
  templateUrl: './scan-qr-modal.component.html',
})
export class ScanQrModalComponent {
  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);

  protected paymentStore = inject(PaymentStore);
  protected translate = inject(TranslateService);
  protected paymentUtils = inject(PaymentUtils);

  public isManual = isManual;

  get wallet() {
    return this.paymentStore.paymentDetails?.().selectedReceiverWallet;
  }

  getAddressViaNetwork() {
    const addresViaNetworkPropertys = {
      payingAsset: this.paymentStore.paymentDetails?.().payingAsset?.assetTicker,
      currentNetwork: this.translate.instant(this.paymentUtils.getNetworkName().toLowerCase() + 'Network'),
    };
    return this.translate.instant('payingAssetViaNetwork', addresViaNetworkPropertys);
  }

  getWrongNetworkInforming() {
    const propertys = {
      assetName: this.paymentStore.paymentDetails?.().payingAsset?.assetName,
      networkName: this.translate.instant(this.paymentUtils.getNetworkName().toLowerCase() + 'Network'),
    };
    return this.translate.instant('thisIsTheAssetAddressForSending', propertys);
  }

  getWalletExchange(onlyWalletInfo?: boolean) {
    const walletProviderName =
      this.paymentStore.paymentDetails?.().selectedReceiverWallet?.cryptoAddress?.cryptoDataSource;

    const termsPhrasePropertys = {
      walletProviderName: this.translate.instant(walletProviderName || ''),
      assetName: this.paymentStore.paymentDetails?.().payingAsset?.assetName,
    };

    let phrase = '';

    if (isManual(walletProviderName)) {
      phrase = `${this.translate.instant('privateWalletProviderInform', termsPhrasePropertys)}`;
    } else {
      phrase = `${this.translate.instant('exchangeWalletProviderInform', termsPhrasePropertys)}`;
    }

    if (onlyWalletInfo) {
      return phrase;
    }

    return `${phrase} ${this.translate.instant('nickyIsAPeerToPeer')}`;
  }
}
